import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PAGE_ICONS, PAGE_ROUTES } from 'pages/AnnualUserAccessReview/_const';
import NavCard from '../../components/NavCard';

/**
 * Templated navigation card for Termination functionality for User Access Review Directory
 * @param {object[]} props.staffData list of staff reporting to logged in user
 * @returns navigation card for termination
 */
const TerminateCard = ({ staffData = [] }) => {
	const history = useHistory();

	return staffData.length > 0 ? (
		<NavCard
			title={'Terminate'}
			icon={<PAGE_ICONS.TERMINATE color='secondary' />}
			role={'Administrative'}
			description={
				'Terminate and revoke application access for direct report(s).'
			}
			onClick={() => history.push(PAGE_ROUTES.TERMINATE)}
		/>
	) : null;
};

TerminateCard.propTypes = {
	staffData: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TerminateCard;
